export const LoginTracking = {
  clickedLogin: 'clicked_login',
  successfulLogin: 'successful_login',
  failedLogin: 'failed_login',
  clickedLogout: 'clicked_logout',
  successfulLogout: 'successful_logout',
  failedLogout: 'failed_logout',
  none: '',
  maxAge: 120,
};
